import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";
import { actionsDeprecated } from "./actionsDeprecated";

/**
 * @deprecated This store needs to be moved to search store.
 */
export const initialMarketDynamicsStoreDeprecated = {
    tableView: {},
    selectedBreakdownPeriod: undefined,
    checkedStatusOptions: [],
    selectedListingView: '',
    selectedBreakdownTab: 0,
    shouldShowChart: true,
    listingViewId: undefined,
    overviewStatus: {
        currentTab: 0,
        chartSettings: {
            default: {},
            inventory: {},
            prices: {},
            activity: {},
        }
    },
    marketIndicatorContent: { title: '', description: '' },
};

/**
 * @deprecated This store needs to be moved to search store.
 */
const marketDynamicsStoreDeprecated = (set, get) => ({
    ...initialMarketDynamicsStoreDeprecated,
    ...actionsDeprecated(set, get),
});

/**
 * @deprecated This store needs to be moved to search store.
 */
export const useMarketDynamicsStore = createWithEqualityFn(
    devtools(
        persist(
            marketDynamicsStoreDeprecated,
            {
                name: 'market_dynamics_state_deprecated',
                storage: createJSONStorage(() => localStorage)
            }
        )
    )
);
